import { render, staticRenderFns } from "./AccountConfigDetails.vue?vue&type=template&id=e8038aee"
import script from "./AccountConfigDetails.vue?vue&type=script&lang=js"
export * from "./AccountConfigDetails.vue?vue&type=script&lang=js"
import style0 from "./AccountConfigDetails.vue?vue&type=style&index=0&id=e8038aee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports